export const WIZARD_STEP = {
  START: 0,
  SETUP_JOBTITLE: 1,
  SETUP_DEPARTMENT: 2,
  SETUP_HOME: 3,
  SETUP_GNB_MENU: 4,
  SETUP_BOARD: 5,
  SETUP_ANNIVERSARY: 6,
  STATUS: 7,
  GUIDE_1: 8,
  GUIDE_2: 9,
  GUIDE_3: 10,
  FINISHED: 11,
};

export const HOME_CONFIG_MENU_LABLE = {
  PT: 'PT_USER_CONFIG_DEFAULT_HOME',
  ML: 'PT_USER_CONFIG_INBOX',
};

export const ADMIN_PORTAL_CONFIG_MENU = {
  MEMBERSHIP: 'MC', // 구성원 관리
  BOARD: 'B', // 게시관리
  PORTALBUILDER: 'PB', // 포탈빌더
  APPROVAL: 'A', // 결재 관리
  SCHEDULE: 'S', // 일정/연락처
};

export const PORTAL_MAIN_URL = '/portalapp/home';
